import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78df9bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ac-form-control" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contactTitle" }, "İsim / Unvan *", -1))
const _hoisted_3 = { class: "ac-form-control" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contactEmail" }, "E-posta Adresi", -1))
const _hoisted_5 = { class: "ac-form-control" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contactPhone" }, "Telefon Numarası", -1))
const _hoisted_7 = { class: "ac-form-control" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contactAddress" }, "Adres", -1))
const _hoisted_9 = { class: "ac-form-control" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contactWebsite" }, "Website", -1))
const _hoisted_11 = { class: "form-actions" }
const _hoisted_12 = {
  type: "submit",
  class: "ac-primary-button"
}

import type { AcContactData } from "~/types/crm"
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'contactModal',
  props: {
    isVisible: { type: Boolean },
    isEditing: { type: Boolean },
    existingContact: {},
    modalTitle: {}
  },
  emits: ["closed", "contactSaved"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

// Form data
const contactForm = ref<AcContactData>({
    title: '',
    emailAddress: '',
    phoneNumber: '',
    address: '',
    website: ''
})

// Initialize form with existing contact data if editing
watch(() => props.existingContact, (newContact) => {
    if (newContact && props.isEditing) {
        contactForm.value = {
            title: newContact.title || '',
            emailAddress: newContact.emailAddress || '',
            phoneNumber: newContact.phoneNumber || '',
            address: newContact.address || '',
            website: newContact.website || ''
        }
    }
}, { immediate: true })

// Reset form when modal closes
watch(() => props.isVisible, (isVisible) => {
    if (!isVisible && !props.isEditing) {
        resetForm()
    }
})

const resetForm = () => {
    contactForm.value = {
        title: '',
        emailAddress: '',
        phoneNumber: '',
        address: '',
        website: ''
    }
}




const saveContact = () => {
    // Basic validation - title is required
    if (!contactForm.value.title.trim()) {
        return
    }
    
    // Create a clean contact object (remove empty strings)
    const cleanContact: AcContactData = {
        title: contactForm.value.title.trim()
    }
    
    if (contactForm.value.emailAddress?.trim()) {
        cleanContact.emailAddress = contactForm.value.emailAddress.trim()
    }
    
    if (contactForm.value.phoneNumber?.trim()) {
        cleanContact.phoneNumber = contactForm.value.phoneNumber.trim()
    }
    
    if (contactForm.value.address?.trim()) {
        cleanContact.address = contactForm.value.address.trim()
    }
    
    if (contactForm.value.website?.trim()) {
        cleanContact.website = contactForm.value.website.trim()
    }
    
    emits('contactSaved', cleanContact)
    
    if (!props.isEditing) {
        resetForm()
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(saveContact, ["prevent"]),
    class: "ac-main-form !border-none"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        id: "contactTitle",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactForm.value.title) = $event)),
        type: "text",
        required: "",
        class: "w-full",
        placeholder: "Kişi adı veya şirket unvanı"
      }, null, 512), [
        [_vModelText, contactForm.value.title]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        id: "contactEmail",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactForm.value.emailAddress) = $event)),
        type: "email",
        class: "w-full",
        placeholder: "ornek@email.com"
      }, null, 512), [
        [_vModelText, contactForm.value.emailAddress]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        id: "contactPhone",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactForm.value.phoneNumber) = $event)),
        type: "tel",
        class: "w-full",
        placeholder: "+90 555 123 45 67"
      }, null, 512), [
        [_vModelText, contactForm.value.phoneNumber]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _withDirectives(_createElementVNode("textarea", {
        id: "contactAddress",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactForm.value.address) = $event)),
        class: "w-full",
        rows: "3",
        placeholder: "Tam adres bilgisi"
      }, null, 512), [
        [_vModelText, contactForm.value.address]
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        id: "contactWebsite",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactForm.value.website) = $event)),
        type: "url",
        class: "w-full",
        placeholder: "https://www.example.com"
      }, null, 512), [
        [_vModelText, contactForm.value.website]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (emits('closed'))),
        class: "ac-secondary-button"
      }, " İptal "),
      _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.isEditing ? 'Güncelle' : 'Kaydet'), 1)
    ])
  ], 32))
}
}

})